/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Drop_Zone_HintInputs */

const en_new_project_drop_zone_hint = /** @type {(inputs: New_Project_Drop_Zone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or click to browse your device`)
};

const fr_new_project_drop_zone_hint = /** @type {(inputs: New_Project_Drop_Zone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou cliquez pour parcourir votre appareil`)
};

const de_new_project_drop_zone_hint = /** @type {(inputs: New_Project_Drop_Zone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oder klicken Sie hier, um Ihr Gerät zu durchsuchen`)
};

const it_new_project_drop_zone_hint = /** @type {(inputs: New_Project_Drop_Zone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oppure fai clic per sfogliare il tuo dispositivo`)
};

const ru_new_project_drop_zone_hint = /** @type {(inputs: New_Project_Drop_Zone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`или нажмите, чтобы просмотреть содержимое вашего устройства`)
};

const es_new_project_drop_zone_hint = /** @type {(inputs: New_Project_Drop_Zone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o haga clic para explorar su dispositivo`)
};

const zh_cn2_new_project_drop_zone_hint = /** @type {(inputs: New_Project_Drop_Zone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或点击浏览您的设备`)
};

const ja_new_project_drop_zone_hint = /** @type {(inputs: New_Project_Drop_Zone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`またはクリックしてデバイスを参照`)
};

const hi_new_project_drop_zone_hint = /** @type {(inputs: New_Project_Drop_Zone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`या अपने डिवाइस को ब्राउज़ करने के लिए क्लिक करें`)
};

const pt_pt2_new_project_drop_zone_hint = /** @type {(inputs: New_Project_Drop_Zone_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou clique para navegar no seu dispositivo`)
};

/**
* | output |
* | --- |
* | "or click to browse your device" |
*
* @param {New_Project_Drop_Zone_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_drop_zone_hint = /** @type {((inputs?: New_Project_Drop_Zone_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Drop_Zone_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_drop_zone_hint(inputs)
	if (locale === "de") return de_new_project_drop_zone_hint(inputs)
	if (locale === "it") return it_new_project_drop_zone_hint(inputs)
	if (locale === "ru") return ru_new_project_drop_zone_hint(inputs)
	if (locale === "es") return es_new_project_drop_zone_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_drop_zone_hint(inputs)
	if (locale === "ja") return ja_new_project_drop_zone_hint(inputs)
	if (locale === "hi") return hi_new_project_drop_zone_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_drop_zone_hint(inputs)
	return en_new_project_drop_zone_hint(inputs)
});